var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { TabContext } from './TabContext';
export const useTabContext = () => {
    _react_refresh_temp_1();
    const value = useContext(TabContext);
    if (!value) {
        throw new Error('Tab context not provided!');
    }
    return value;
};
_react_refresh_temp_1(useTabContext, "ksutO2/Ix3UeCrGnhyM+QEP505Y=");
